import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { useI18n } from '../../lib/i18n';
import { LanguageSwitcher } from '../ui/LanguageSwitcher';
import { SmartImage } from '../common/SmartImage';
import { IMAGES } from '../../lib/images';
const navItems = [{
  to: '/',
  key: 'nav_home'
}, {
  to: '/about',
  key: 'nav_about'
}, {
  to: '/journey',
  key: 'nav_journey'
}, {
  to: '/contact',
  key: 'nav_contact'
}];
export function Header() {
  const {
    t
  } = useI18n();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className="glass-header sticky top-0 z-50" data-id="element-85" data-mp="39jsw2hr668w">
      <div className="mx-auto flex h-16 max-w-container items-center justify-between px-4 sm:px-6" data-id="element-86" data-mp="37yyqdzcopbk">
        <Link to="/" className="flex items-center gap-2.5" aria-label="SATEV Group home" data-id="element-87" data-mp="3uesa2anuy4tt">
          <SmartImage src={IMAGES.companyLogo} alt="SATEV Group logo" className="h-9 w-9 rounded-md object-contain" data-id="element-88" data-mp="bu891v9taaw6" />
          <span className="text-lg font-bold tracking-wide text-white brand-glow" data-id="element-89" data-mp="gnudx19qhahf">
            SATEV{' '}
            <span className="font-normal text-silver" data-id="element-90" data-mp="lme4jez9vag4">{t('brand_group')}</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="Primary" data-id="element-91" data-mp="3p19y73xnf3pc">
          {navItems.map(item => <NavLink key={item.to} to={item.to} end={item.to === '/'} className={({
          isActive
        }) => `rounded-md px-3 py-2 text-sm font-medium transition-colors ${isActive ? 'text-neon' : 'text-silver hover:text-white'}`} data-id="element-92" data-mp="3u04un8ojgqrx">
              {t(item.key)}
            </NavLink>)}
          <div className="ml-2" data-id="element-93" data-mp="3ac4xpj0eaqki">
            <LanguageSwitcher data-id="element-94" data-mp="3abbugs0naj74" />
          </div>
        </nav>

        <div className="flex items-center gap-2 md:hidden" data-id="element-95" data-mp="35dk6ua719j8q">
          <LanguageSwitcher data-id="element-96" data-mp="35d0oisdh0su6" />
          <button type="button" onClick={() => setOpen(v => !v)} aria-label={open ? t('close') : t('nav_menu')} aria-expanded={open} className="rounded-md p-2 text-white hover:bg-[rgba(217,217,217,0.1)]" data-id="element-97" data-mp="3jd30xz30eu21">
            {open ? <XIcon className="h-6 w-6" data-id="element-98" data-mp="2mmsmkdlic8fk" /> : <MenuIcon className="h-6 w-6" data-id="element-99" data-mp="2monc657q4opz" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-100" data-mp="30fic2s08vvhf">
        {open && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.25
      }} className="overflow-hidden border-t border-[rgba(217,217,217,0.1)] md:hidden" data-id="element-101" data-mp="2vmyz9x9dt4do">
            <nav className="mx-auto flex max-w-container flex-col gap-1 px-4 py-4" aria-label="Mobile" data-id="element-102" data-mp="n9lsg00tjgx3">
              {navItems.map(item => <NavLink key={item.to} to={item.to} end={item.to === '/'} className={({
            isActive
          }) => `rounded-md px-3 py-3 text-base font-medium transition-colors ${isActive ? 'bg-[rgba(255,113,1,0.12)] text-neon' : 'text-silver hover:bg-[rgba(217,217,217,0.08)] hover:text-white'}`} data-id="element-103" data-mp="effeqt6ynp9v">
                  {t(item.key)}
                </NavLink>)}
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}